import { defineComponent as _defineComponent } from 'vue';
import { HARDWARE_LEGEND } from './helpers/frameConstants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HardwareLegend',
    props: {
        print: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { get HARDWARE_LEGEND() { return HARDWARE_LEGEND; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
